import { formatMoneyFromMinorUnits, formatPartnerMoneyFromMicroUnits } from '../../../shared/lib/money.js';

function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) return '-';
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString();
}

export function buildPartnerDetailsModel(dto) {
  if (!dto) return null;
  return {
    uid: dto.uid,
    status: dto.status,
    referralCode: dto.referralCode,
    referralToken: dto.referralToken,
    profileUid: dto.profileUid,
    profileName: dto.profileName,
    parentUid: dto.parentUid,
    parentName: dto.parentUid ? dto.parentName : '',
    commissionPlanUid: dto.commissionPlanUid,
    commissionPlanName: dto.commissionPlanName,
    hasWallet: Boolean(dto.walletUid),
    walletBalanceFormatted: formatPartnerMoneyFromMicroUnits(dto.walletBalanceMicro, dto.walletCurrency),
    walletTotalEarnedFormatted: formatPartnerMoneyFromMicroUnits(dto.walletTotalEarnedMicro, dto.walletCurrency),
    walletTotalWithdrawnFormatted: formatPartnerMoneyFromMicroUnits(dto.walletTotalWithdrawnMicro, dto.walletCurrency),
    walletCurrency: dto.walletCurrency,
    createdAt: formatDate(dto.created),
  };
}

export function buildPartnerTreeModel(dtoNodes) {
  return dtoNodes.map((node) => ({
    key: node.key,
    uid: node.uid,
    name: node.name,
    depth: node.depth,
    referralCount: node.referralCount,
    monthlyEarningsFormatted: node.monthlyEarningsMicro
      ? formatPartnerMoneyFromMicroUnits(node.monthlyEarningsMicro, node.currency)
      : node.monthlyEarningsMinor
        ? formatMoneyFromMinorUnits(node.monthlyEarningsMinor, node.currency)
      : '\u2014',
  }));
}

export function buildPartnerCommissionsModel(dtoCommissions) {
  return dtoCommissions.map((c) => ({
    key: c.key,
    uid: c.uid,
    type: c.type,
    status: c.status,
    depth: c.depth,
    lots: c.lots || '\u2014',
    amountFormatted: formatPartnerMoneyFromMicroUnits(c.amountMicro, c.currency),
    clientUid: c.clientUid,
    clientName: c.clientName,
    createdAt: formatDate(c.created),
  }));
}

export function buildPartnerReferralsModel(dto) {
  return {
    referrals: dto.referrals.map((row) => ({
      key: row.key,
      profileUid: row.profileUid,
      email: row.email,
      fullName: row.fullName,
      status: row.status,
      createdAt: formatDate(row.created),
      accountsCount: row.accountsCount,
    })),
    total: dto.total,
  };
}
